export var brokingPlanMapper = function (data) {
    var result = [];
    if (data && data.length > 0) {
        result = data;
    }
    return result;
};
